import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api, { apiErr } from "./api";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=anon, obj=auth
  const [booting, setBooting] = useState(true);

  const loadMe = useCallback(async () => {
    const t = localStorage.getItem("tf_token");
    if (!t) { setUser(false); setBooting(false); return; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      localStorage.removeItem("tf_token");
      setUser(false);
    } finally {
      setBooting(false);
    }
  }, []);

  useEffect(() => { loadMe(); }, [loadMe]);

  const login = async (email, password, opts = {}) => {
    try {
      const { data } = await api.post("/auth/login", { email, password, ...opts });
      localStorage.setItem("tf_token", data.token);
      await loadMe();
      return { ok: true, user: data.user };
    } catch (e) {
      return { ok: false, error: apiErr(e) };
    }
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("tf_token");
    setUser(false);
    window.location.href = "/login";
  };

  return (
    <AuthCtx.Provider value={{ user, booting, login, logout, refresh: loadMe }}>
      {children}
    </AuthCtx.Provider>
  );
}
